"use client"

import * as React from "react"

import { useActiveWorkspaceSlug } from "@/features/auth/hooks/use-active-workspace-slug"
import { useTenantAuthFlow } from "@/features/auth/providers/tenant-auth-flow-provider"
import { resolveWorkspaceAccessRecord } from "@/features/dashboard/model/church-nav"

export function useCurrentWorkspaceAccess() {
  const { authMe } = useTenantAuthFlow()
  const activeWorkspaceSlug = useActiveWorkspaceSlug()
  const currentWorkspaceAccess = React.useMemo(
    () => resolveWorkspaceAccessRecord(authMe, activeWorkspaceSlug ?? null),
    [activeWorkspaceSlug, authMe],
  )

  return currentWorkspaceAccess
}
